/**
 * File: apps/qbench-cp/reactapp/src/shared/components/Tours/Tooltip.js
 *
 * Purpose: Renders the tooltip/popover shown at each step of the onboarding product tour.
 *
 * Scope: OnboardingTooltip component consumed by the Onboarding tour.
 *
 * Tags: customer-portal
 *
 * Overview: Displays the current step's content text, a primary continue button (spreading
 *     react-joyride's primaryProps) shown when the tour is continuous, and a skip/dismiss text
 *     button shown on all but the last step, plus a "current of total" step counter. Styling
 *     and button wiring are supplied entirely by the props react-joyride passes to a custom
 *     tooltip component.
 *
 * Exports: OnboardingTooltip (default export).
 */

import styled from 'styled-components';
import { Stack } from 'react-bootstrap';
import Button from 'shared/components/common/Button';

const Wrapper = styled.div`
  color: ${({ theme }) => theme.color.palette.text.main};
  background-color: ${({ theme }) => theme.color.palette.grey[100]};
  border: 1px solid ${({ theme }) => theme.color.palette.grey[200]};

  @media ${({ theme }) => theme.device.desktop} {
    width: 18rem;
  }

  > :last-child {
    color: ${({ theme }) => theme.color.palette.grey[500]};
  }
`;

export default function OnboardingTooltip(props) {
  const {
    step,
    index,
    size,
    skipProps,
    isLastStep,
    continuous,
    tooltipProps,
    primaryProps,
  } = props;

  return (
    <Wrapper className="fs-7 w-70 p-3 rounded" {...tooltipProps}>
      <p className="mb-4 text-center lh-base">{step.content}</p>
      <Stack direction="horizontal" gap={2} className="justify-content-center">
        {continuous && (
          <Button className="" {...primaryProps}>
            {primaryProps.title}
          </Button>
        )}
        {!isLastStep && (
          <Button type="text" className="" {...skipProps}>
            {skipProps.title}
          </Button>
        )}
      </Stack>
      <div className="mt-3 text-center fs-8 fw-semibold text-uppercase lh-1">
        {index + 1} OF {size}
      </div>
    </Wrapper>
  );
}
